import { render, staticRenderFns } from "./PageStadiumBoosts.vue?vue&type=template&id=582869c8&"
import script from "./PageStadiumBoosts.vue?vue&type=script&lang=js&"
export * from "./PageStadiumBoosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports